import base from "/opt/build/repo/images/atmos.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");